/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useState } from 'react';
import { Box, Fab, Grid, TextField } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined';
import { Autocomplete } from '@material-ui/lab';
import OptionItemData from '../Shared/OptionItemData';
import { yup } from '../constants';
import { itemClasses } from '../themes/classes';
import { PopupDialog } from '../Shared';
import { useDepartments, useEmployees, useTemplate } from '../hooks';
import AutoFieldLocal from '../components/fields/AutoFieldLocal';
import useResourses from '../hooks/useResourses';
import useTasks from '../hooks/useTasks';

export const indexTheList = (list: any) => {
  return list.map((item: any, index: any) => {
    return {
      ...item,
      index,
    };
  });
};

const PopupItem = ({
  open,
  onClose,
  row,
  editAction,
  isRTL,
  words,
  user,
  products,
  itemrelations,
}: any) => {
  const classes = itemClasses();
  const [itemError, setItemError] = useState<any>(false);
  const [desc, setDesc] = useState('');
  const [manualDocNo, setManualDocNo] = useState('');
  const [manualRefNo, setManualRefNo] = useState('');

  const [itemvalue, setItemvalue] = useState<any>(null);
  const [itemqty, setItemqty] = useState(1);
  const [itemprice, setItemprice] = useState(0);

  const [departvalue, setDepartvalue] = useState<any>(null);
  const [emplvalue, setEmplvalue] = useState<any>(null);
  const [taskvalue, setTaskvalue] = useState<any>(null);
  const [resovalue, setResovalue] = useState<any>(null);

  const { resourses } = useResourses();
  const { tasks } = useTasks();

  const { tempoptions, tempwords } = useTemplate();
  const { departments } = useDepartments();
  const { wemployees: employees } = useEmployees();

  const { register, handleSubmit, errors } = useForm(yup.invItemResolver);

  const itemRef: any = React.useRef();

  useEffect(() => {
    if (row && row._id) {
      setItemprice(row.itemprice);
      setItemqty(row.itemqty);
      const servId = row._id;
      if (servId) {
        const serv = products?.filter((se: any) => se._id === servId)[0];
        setItemvalue(serv);
      }
      const depId = row?.departmentId;
      const empId = row?.employeeId;
      const resId = row?.resourseId;

      const contractId = row?.contractId;

      if (contractId) {
        const tsk = tasks.filter((ts: any) => ts._id === contractId)[0];
        setTaskvalue(tsk);
      }
      if (resId) {
        const res = resourses.filter((emp: any) => emp._id === resId)[0];
        setResovalue(res);
      }
      if (depId) {
        const depart = departments.filter((dep: any) => dep._id === depId)[0];
        setDepartvalue(depart);
      }
      if (empId) {
        const empl = employees.filter((emp: any) => emp._id === empId)[0];
        setEmplvalue(empl);
      }
      setDesc(row?.note);
      setManualDocNo(row?.manualDocNo);
      setManualRefNo(row?.manualRefNo);
    }
  }, [open]);

  const resetAll = () => {
    setItemprice(0);
    setItemqty(1);
    setItemvalue(null);
    setDepartvalue(null);
    setEmplvalue(null);
    setTaskvalue(null);
    setResovalue(null);
    setDesc('');
    setManualDocNo('');
    setManualRefNo('');
  };

  const editLocalItem = () => {
    if (!itemvalue) {
      setItemError(true);
      itemRef.current.focus();
      return;
    }
    const itemdata = {
      ...itemvalue,
      itemqty,
      itemprice,
      itemtotal: itemqty * itemprice,
      itemtotalcost: itemqty * itemvalue.cost,
      departmentId: departvalue?._id,
      departmentName: departvalue?.name,
      departmentNameAr: departvalue?.nameAr,
      departmentColor: departvalue?.color,
      employeeId: emplvalue?._id,
      employeeName: emplvalue?.name,
      employeeNameAr: emplvalue?.nameAr,
      employeeColor: emplvalue?.color,
      employeePhone: emplvalue?.phone,
      contractId: taskvalue?._id,
      contractName: taskvalue?.name,
      contractNameAr: taskvalue?.nameAr,
      projectId: taskvalue?.projectId,
      projectName: taskvalue?.projectName,
      projectNameAr: taskvalue?.projectNameAr,
      resourseId: resovalue?._id,
      resourseName: resovalue?.name,
      resourseNameAr: resovalue?.nameAr,
      resourseColor: resovalue?.color,
      index: row?.index,
      note: desc,
      manualDocNo,
      manualRefNo,
      userId: user._id,
    };
    editAction(itemdata);
    onFormClose();
  };
  const onFormClose = () => {
    onClose();
    resetAll();
  };

  return (
    <PopupDialog
      open={open}
      onClose={onFormClose}
      maxWidth={'lg'}
      classes={classes}
    >
      <Box
        display="flex"
        style={{
          flex: 1,
          margin: 20,
          direction: isRTL ? 'rtl' : 'ltr',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Autocomplete
              autoSelect
              size="small"
              options={products}
              getOptionLabel={(option: any) =>
                isRTL ? option.nameAr : option.name
              }
              getOptionSelected={(option, values) => option._id === values._id}
              renderOption={(option) => (
                <OptionItemData item={option}></OptionItemData>
              )}
              disabled={true}
              value={itemvalue}
              onChange={(_, newValue: any) => {
                setItemvalue(newValue);
                if (newValue) {
                  setItemError(false);
                }
              }}
              style={{ direction: isRTL ? 'rtl' : 'ltr' }}
              classes={{ input: classes.smallFont }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  id="service"
                  name="service"
                  label={words.service}
                  error={itemError}
                  variant="outlined"
                  inputRef={(ref) => {
                    itemRef.current = ref;
                  }}
                  InputLabelProps={{
                    style: { fontSize: 13 },
                  }}
                  fullWidth
                ></TextField>
              )}
            />
          </Grid>
          <Grid item xs={4} md={2}>
            <TextField
              name="qty"
              onChange={(e: any) => setItemqty(Number(e.target.value))}
              value={itemqty}
              label={words.qty}
              variant="outlined"
              inputRef={register}
              type="number"
              error={errors.qty ? true : false}
              fullWidth
              margin="dense"
              onFocus={(e) => e.target.select()}
              // inputProps={{
              //   style: { textAlign: 'right', fontSize: 13, height: 13 },
              //   inputMode: 'decimal',
              // }}
            />
          </Grid>
          <Grid item xs={5} md={3}>
            <TextField
              name="price"
              onChange={(e: any) => setItemprice(Number(e.target.value))}
              value={itemprice}
              label={words.theprice}
              error={errors.price ? true : false}
              variant="outlined"
              inputRef={register}
              type="number"
              fullWidth
              margin="dense"
              onFocus={(e) => e.target.select()}
              // inputProps={{
              //   style: { textAlign: 'right', fontSize: 13, height: 13 },
              //   inputMode: 'decimal',
              // }}
            />
          </Grid>
          <Grid item xs={3} md={1}>
            <Fab
              style={{ marginLeft: 10, marginRight: 10, marginTop: 5 }}
              color="primary"
              size="small"
              onClick={handleSubmit(editLocalItem)}
              title="Create new row"
            >
              <SaveOutlinedIcon />
            </Fab>
          </Grid>
          {itemrelations && (
            <>
              {tempoptions?.contract && (
                <Grid item xs={12} md>
                  <AutoFieldLocal
                    name="task"
                    title={tempwords?.task}
                    words={words}
                    options={tasks}
                    value={taskvalue}
                    setSelectValue={setTaskvalue}
                    isRTL={isRTL}
                    fullWidth
                    mb={0}
                  ></AutoFieldLocal>
                </Grid>
              )}
              {tempoptions?.employee && (
                <Grid item xs={12} md>
                  <AutoFieldLocal
                    name="employee"
                    title={tempwords?.employee2}
                    words={words}
                    options={employees.filter((emp: any) => !emp.disabled)}
                    value={emplvalue}
                    setSelectValue={setEmplvalue}
                    isRTL={isRTL}
                    fullWidth
                    mb={0}
                  ></AutoFieldLocal>
                </Grid>
              )}
              {tempoptions?.department && (
                <Grid item xs={12} md>
                  <AutoFieldLocal
                    name="department"
                    title={tempwords?.department}
                    words={words}
                    options={departments.filter((d: any) => d.depType === 1)}
                    value={departvalue}
                    setSelectValue={setDepartvalue}
                    isRTL={isRTL}
                    fullWidth
                    mb={0}
                  ></AutoFieldLocal>
                </Grid>
              )}
              {tempoptions?.resourse && (
                <Grid item xs={12} md>
                  <AutoFieldLocal
                    name="resourse"
                    title={tempwords?.resourse}
                    words={words}
                    options={resourses.filter((emp: any) => !emp.disabled)}
                    value={resovalue}
                    setSelectValue={setResovalue}
                    isRTL={isRTL}
                    fullWidth
                    mb={0}
                  ></AutoFieldLocal>
                </Grid>
              )}
            </>
          )}
          {tempoptions?.itemdescription && (
            <Grid item xs={12} md={8}>
              <div>
                <TextField
                  name="desc"
                  onChange={(e: any) => setDesc(e.target.value)}
                  value={desc}
                  label={words.description}
                  variant="outlined"
                  margin="dense"
                  onFocus={(e) => e.target.select()}
                  fullWidth
                  multiline
                  rowsMax={1}
                  rows={1}
                  style={{ margin: 0 }}
                />
              </div>
            </Grid>
          )}
          <Grid item xs={12} md={2}>
            <TextField
              name="manualDocNo"
              onChange={(e: any) => setManualDocNo(e.target.value)}
              value={manualDocNo}
              label={isRTL ? 'رقم المستند' : 'Document No'}
              variant="outlined"
              margin="dense"
              fullWidth
              style={{ margin: 0 }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              name="manualRefNo"
              onChange={(e: any) => setManualRefNo(e.target.value)}
              value={manualRefNo}
              label={isRTL ? 'رقم المرجع' : 'Reference No'}
              variant="outlined"
              margin="dense"
              fullWidth
              style={{ margin: 0 }}
            />
          </Grid>
        </Grid>
      </Box>
    </PopupDialog>
  );
};

export default PopupItem;
